import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PdfRepository } from '@app/domain/repositories/ptrab/pdf/pdf.repository.contract';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class PdfRepositoryImpl extends MRepository implements PdfRepository {
  constructor() {
    super(`${ENV.API_URL_PTRAB}`);
  }

  fetch(url: string, params = {}): Observable<void> {
    return this.get(url, { params, responseType: 'arraybuffer' });
  }

  fetchDirectDebitPdf(url: string): Observable<MSafeAny> {
    return this.post(url, { responseType: 'arraybuffer' });
  }
}
